export class CustomSelect{
  showLanguage: boolean = null;
  showUser: boolean = null;
}
